export interface Contact {
  salutation: string;
  title: string;
  name: string;
  function: string;
  email: string;
  phone: string;
  mobilephone: string;
}

export function newContact(): Contact {
  return {
    salutation: "",
    title: "",
    name: "",
    function: "",
    email: "",
    phone: "",
    mobilephone: "",
  };
}
